.table-container {
  display: inline-block;
  width: 100%;
}

.table-container ul.heading {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.table-container ul.heading > li {
  font-weight: 600;
  padding: 0.45rem 0;
}

/* Note: the entire selector including `:hover` is wrapped in `:where()` so
 * the rule has specificity 0. Any consumer-side tailwind utility (even one as
 * weak as `hover:bg-*` at (0,2,0)) will win, which is what we want so pages
 * like RoyaltySplits can keep their bluish hover. */
:where(.table-container .line > ul:hover) {
  background-color: var(--theme-table-row-hover);
}

/* Note: subtle drop-shadow under the sticky header that fades in once the
 * table body has been scrolled away from the top. Gives a "lifted" feel. */
.data-table-sticky-head::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: -8px;
  height: 8px;
  pointer-events: none;
  opacity: 0;
  background: linear-gradient(to bottom, var(--theme-table-border), transparent);
  transition: opacity 180ms ease;
}

.data-table-sticky-head--scrolled::after {
  opacity: 1;
}

/* Note: soft theme-matched focus ring inside table cells. Targets the base-ui
 * NumberField group (rendered as a role="group" div) and any non-MUI button
 * within the table area. MUI components keep their own focus styling. The
 * full selector lives inside `:where()` so consumer focus utilities win. */
:where(.table-container div[role="group"]:focus-within),
:where(.table-container button:focus-visible) {
  outline: 2px solid var(--theme-info);
  outline-offset: 1px;
  border-radius: 3px;
}

.table-container ul, .table-container .line > ul {
  display: flex;
  justify-content: space-between;
  gap: 0.5rem;
}

.table-container ul > li, .table-container .line > ul li {
  line-height: 1.2rem;
  white-space: normal;
  word-break: break-word;
  text-overflow: initial;
  border-collapse: collapse;
}

.table-container ul > li > span, .table-container .line > ul li > span {
  overflow-y: auto;
}
